<template >
    <g id="sd-squiggles">
        <path
            d="M 0 8 q 16 16 32 0 t 32 0 t 32 0 t 32 0"
            stroke-width="8"
            fill="none"
            :stroke="fill"
        ></path>
        <path
            d="M 0 40 q 16 16 32 0 t 32 0 t 32 0 t 32 0"
            stroke-width="8"
            fill="none"
            :stroke="fill"
        ></path>
        <path
            d="M 0 72 q 16 16 32 0 t 32 0 t 32 0 t 32 0"
            stroke-width="8"
            fill="none"
            :stroke="fill"
        ></path>
    </g>
</template>

<script>
export default {
    props: {
        fill: {
            type: String,
            default: '#ffffff'
        }
    }
}
</script>


